import React from 'react';
import MarkdownIt from 'markdown-it';
import s from '../../Feature.module.scss';
import ContentfulImage, { FluidImage } from '../../../../../components/ContentfulImage';
import RichText from '../../../../../components/RichText';
import { CaseStudyFeature } from '../../../../../constants/types';

const md = new MarkdownIt({
  html: true,
  linkify: false,
});

interface ViewType3Props {
  item: CaseStudyFeature;
}

const ViewType3: React.FC<ViewType3Props> = ({ item }) => {
  const { description, imageSliders, hideTitle, title, backgroundColor } = item;
  
  return (
    <div className={s.root}>
      <div
        className={[s.viewType3, s.container].join(' ')}
        style={{ background: backgroundColor || '' }}
        data-testid="viewtype3-container"
      >
        <div className={s.subContainer}>
          <div className={s.textBlock}>
            {!hideTitle && (
              <h2 className={s.title} data-testid="viewtype3-title">
                {title}
              </h2>
            )}
            <div className={s.content} data-testid="viewtype3-content">
              {description && <RichText data={description}/>}
            </div>
          </div>
        </div>
        <div className={s.imageSection}>
          {imageSliders && imageSliders.map((img) => 
              <div className={s.imageItem} key={img.id}>
                {img?.image?.fluid && <ContentfulImage
                  alt={title}
                  fluid={img?.image?.fluid}
                  dataTestId={`viewtype3-image-${img.id}`}
                />}
              </div>
            )
          }
          {/* {imageSliders.map((img) => (
            <div className={s.imageItem} key={img.id}>
              <ContentfulImage
                fluid={img.fluid}
                alt={img.fluid.alt || title}
                dataTestId={`viewtype3-image-${img.id}`}
              />
            </div>
          ))} */}
        </div>
      </div>
    </div>
  );
};

export default ViewType3;
